import React from "react";
import Slider from "react-slick";
import cn from "classnames";

//import images
import pg from "../../assets/images/home/service/pg.png";
import ac from "../../assets/images/home/service/ac.png";
import hx from "../../assets/images/home/service/hx.png";
import hs from "../../assets/images/home/service/hs.jpg";

import dx from "../../assets/images/home/service/dx.jpg";
import tff from "../../assets/images/home/service/tff.jpg";
import xz from "../../assets/images/home/service/xz.png";
import snd from "../../assets/images/home/service/snd.jpg";

import dy from "../../assets/images/home/service/dy.png";
import bv from "../../assets/images/home/service/bv.png";
import hr from "../../assets/images/home/service/hr.png";
import yl from "../../assets/images/home/service/yl.png";

import zy from "../../assets/images/home/service/zy.png";
import cms from "../../assets/images/home/service/cms.png";
import rn from "../../assets/images/home/service/rn.png";
import jccfc from "../../assets/images/home/service/jccfc.jpg";

import "../../assets/css/slick.css";
import "../../assets/css/slick-theme.css";
import { Link } from "gatsby";

const Service = () => {
  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0px",
    slidesToShow: 3,
    speed: 1000,
    rows: 2,
    slidesPerRow: 2,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const services = [
    { src: dy, alt: "大任人力资源软件 电影电视学院", classNames: ["pt-3", "pb-3"] },
    { src: hx, alt: "大任人力资源软件 华夏航空", classNames: ["pt-3", "pb-3"] },
    { src: bv, alt: "大任人力资源软件 bravou", classNames: ["pt-3", "pb-3"] },
    { src: hr, alt: "大任人力资源软件 华润", classNames: ["pt-3", "pb-3"] },
    { src: dx, alt: "大任人力资源软件 中国电信", classNames: ["pt-3", "pb-3"] },
    { src: yl, alt: "大任人力资源软件 世纪游轮", classNames: ["pt-3", "pb-3"] },
    { src: tff, alt: "大任人力资源软件 积微", classNames: ["pt-3", "pb-3"] },
    { src: jccfc, alt: "大任人力资源软件 锦程", classNames: ["pt-5", "pb-5"] },
    { src: rn, alt: "大任人力资源软件 骨科医院", classNames: ["pt-3", "pb-3"] },
    { src: ac, alt: "大任人力资源软件 安诚", classNames: ["pt-3", "pb-3"] },
    { src: snd, alt: "大任人力资源软件 中国移动", classNames: ["pt-3", "pb-3"] },
    { src: pg, alt: "大任人力资源软件 攀钢", classNames: ["pt-3", "pb-3"] },
    { src: cms, alt: "大任人力资源软件 cms", classNames: ["pt-3", "pb-3"] },
    { src: zy, alt: "大任人力资源软件 青山利康", classNames: ["pt-3", "pb-3"] },
    { src: hs, alt: "大任人力资源软件 华神", classNames: ["pt-3", "pb-3"] },
    { src: xz, alt: "大任人力资源软件 西藏航空", classNames: ["pt-3", "pb-3"] },
  ];

  return (
    <section className="featured-services-area pt-70">
      <div className="container">
        <Slider {...settings} className="owl-carousel owl-theme">
          {services.map(({ classNames, ...rest }) => (
            <Link to="/trends/page_1" className={cn("features text-center ", ...classNames)}>
              <img className="img-fluid" {...rest} />
            </Link>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Service;
